import { isDateEmpty } from "@/common/validation-checkers";
import React from 'react';
import DatePicker from 'react-datepicker';
import "./datepicker_fix.scss";
import ConvertToDate from "@/common/convert-to";

interface IProps {
    value?: Date;
    purpose: string;
    newValue: (val: Date | null | undefined) => void;
}

const DatePickerComponent: React.FC<IProps> = ({value, purpose, newValue}) => {

    value = ConvertToDate(value);

    const years: number[] = [];
    for (let i = 2017; i <= new Date().getFullYear()+2; i++) {
        years.push(i);
    }

    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    return (
        <div className="mx-4 mt-1">
            <label className='py-1 block text-gray-200 text-md' htmlFor={purpose}>{purpose}</label>
            
            <DatePicker
                className="text-black px-2 py-1 block w-full"
                id={purpose}
                selected={value}
                onChange={(date) => newValue(isDateEmpty(date) ? undefined : date)}
                calendarStartDay={1}
                dateFormat="dd/MM/yyyy"
                renderCustomHeader={({
                    date,
                    changeYear,
                    changeMonth,
                    decreaseMonth,
                    increaseMonth,
                    prevMonthButtonDisabled,
                    nextMonthButtonDisabled,
                }) => (
                    <div
                        style={{
                            margin: 10,
                            display: "flex",
                            justifyContent: "center",
                        }}
                        tabIndex={-1}
                    >
                        <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} tabIndex={-1}>
                            {"<"}
                        </button>

                        <select
                            value={months[date.getMonth()]}
                            onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}
                            tabIndex={-1}
                        >
                            {months.map((option) => (
                                <option key={option} value={option} tabIndex={-1}>
                                    {option}
                                </option>
                            ))}
                        </select>

                        <select
                            value={date.getFullYear()}
                            onChange={({ target: { value } }) => changeYear(Number(value))}
                            tabIndex={-1}
                        >
                            {years.map((option) => (
                            <option key={option} value={option} tabIndex={-1}>
                                {option}
                            </option>
                            ))}
                        </select>

                        <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} tabIndex={-1}>
                            {">"}
                        </button>
                    </div>
                )}
            />
        </div>
    )
}

export default DatePickerComponent;